var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"flex items-center justify-between flex-shrink-0 p-4 border-t max-h-14 bg-gray-200"},[_c('div',[_vm._v("OSM © 2023")]),_vm._v(" "),_c('div',{staticClass:"text-sm"},[_vm._v("\nOpen Source Management\n    ")])])
}]

export { render, staticRenderFns }